import type { StoryblokContent } from '../storyblok'
import type { FaqSectionHighlightSchema } from './faq-section-highlight'
import type { Link } from './shared'

export interface FaqSectionSchema extends StoryblokContent {
  component: 'faq-section'
  title: string
  highlights?: FaqSectionHighlightSchema[]
  cta_link: Link
  cta_title: string
}

export function isFaqSection(content: StoryblokContent): content is FaqSectionSchema {
  return content.component === 'faq-section'
}
